import { CurrencyCode } from "shared/types";

export const formatMoney = (
	amount: number,
	customOptions: {
		minimumFractionDigits?: number;
		maximumFractionDigits?: number;
		currency?: null | string | CurrencyCode;
		style?: "decimal" | "currency" | "percent" | "unit";
	} = {
		minimumFractionDigits: 2,
		currency: CurrencyCode.USD
	}
) =>
	new Intl.NumberFormat("en-US", {
		style: "currency",
		...customOptions,
		currency: customOptions.currency ? customOptions.currency.toUpperCase() : CurrencyCode.USD.toUpperCase()
	}).format(amount / 100);
